import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { listProductDetails, updateProduct } from "../actions/productActions";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { PRODUCT_UPDATE_RESET } from "../constants/productConstans";
import axios from "axios";

/* ------------------------------------------------------------------ */
/* Live preview — mirrors what the home tile (Product.js) will render */
/* ------------------------------------------------------------------ */
const generoMap = {
  dama: "DAMA",
  caballero: "CABALLERO",
  unisex: "UNISEX",
};

const ProductPreview = ({
  name,
  price,
  image,
  brand,
  tipo,
  genero,
  inspo,
  profile,
  notes,
  volume,
  badge,
}) => {
  const kickerParts = [];
  if (tipo === "perfumes" && genero) kickerParts.push(generoMap[genero] || "");
  if (profile) kickerParts.push(profile.toUpperCase());
  const kicker = kickerParts.filter(Boolean).join(" · ");

  const noteList = (notes || "")
    .split(",")
    .map((n) => n.trim())
    .filter(Boolean);

  const priceNum = Number(price);
  const priceLabel = isNaN(priceNum) ? "—" : priceNum.toFixed(2);

  return (
    <div className="hadacy-pep-wrap">
      <style>{`
        .hadacy-pep-wrap {
          position: sticky;
          top: 1rem;
          font-family: "Jost", sans-serif;
        }
        .hadacy-pep-label {
          font-size: 0.65rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: #b8933a;
          margin-bottom: 0.6rem;
          text-align: center;
        }
        .hadacy-pep-card {
          background: #faf7f2;
          border: 1px solid rgba(184,147,58,0.18);
          border-radius: 18px;
          padding: 1rem;
          box-shadow: 0 10px 25px rgba(26,20,16,0.06);
          position: relative;
        }
        .hadacy-pep-img-wrap {
          width: 100%;
          aspect-ratio: 1 / 1;
          border-radius: 18px;
          overflow: hidden;
          background: linear-gradient(135deg, rgba(184,147,58,0.08), rgba(232,213,196,0.20));
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .hadacy-pep-img-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .hadacy-pep-img-empty {
          color: #b8a98c;
          font-size: 0.75rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
        }
        .hadacy-pep-badge {
          position: absolute;
          top: 1.4rem;
          left: 1.4rem;
          background: #1a1410;
          color: #d4af6a;
          font-size: 0.55rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          padding: 0.25rem 0.55rem;
          border-radius: 999px;
        }
        .hadacy-pep-body { padding: 0.9rem 0.4rem 0.4rem; }
        .hadacy-pep-kicker {
          font-size: 0.62rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: #b8933a;
          margin-bottom: 0.25rem;
          display: block;
        }
        .hadacy-pep-name {
          font-family: "Cormorant Garamond", "Playfair Display", serif;
          font-weight: 400;
          font-size: 1.35rem;
          color: #1a1410;
          margin: 0;
          line-height: 1.1;
        }
        .hadacy-pep-inspo {
          font-family: "Cormorant Garamond", "Playfair Display", serif;
          font-style: italic;
          font-size: 0.92rem;
          color: #7a6e62;
          margin: 0.3rem 0 0.1rem;
          display: block;
        }
        .hadacy-pep-brand {
          font-size: 0.7rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: #a59786;
          display: block;
        }
        .hadacy-pep-stars {
          color: #d4af6a;
          font-size: 0.85rem;
          margin: 0.5rem 0 0.4rem;
        }
        .hadacy-pep-stars .reviews {
          color: #a59786;
          font-size: 0.72rem;
          margin-left: 0.4rem;
        }
        .hadacy-pep-price {
          font-family: "Jost", sans-serif;
          color: #b8933a;
          font-weight: 500;
          font-size: 1.25rem;
          margin: 0;
        }
        .hadacy-pep-price .mxn { font-size: 0.65rem; margin-left: 0.15rem; color: #b8933a; }
        .hadacy-pep-volume {
          display: inline-block;
          margin-left: 0.5rem;
          padding: 0.15rem 0.55rem;
          border: 1px solid rgba(184,147,58,0.28);
          border-radius: 999px;
          font-size: 0.62rem;
          letter-spacing: 0.18em;
          color: #7a6e62;
          vertical-align: middle;
        }
        .hadacy-pep-notes {
          display: flex;
          flex-wrap: wrap;
          gap: 0.3rem;
          margin-top: 0.5rem;
        }
        .hadacy-pep-tag {
          font-size: 0.58rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          padding: 0.18rem 0.5rem;
          border: 1px solid rgba(184,147,58,0.28);
          color: #b8933a;
          border-radius: 1px;
        }
        .hadacy-pep-tip {
          margin-top: 0.9rem;
          font-size: 0.7rem;
          color: #a59786;
          text-align: center;
          font-style: italic;
        }
      `}</style>

      <div className="hadacy-pep-label">Vista previa en vivo</div>

      <div className="hadacy-pep-card">
        {badge && <span className="hadacy-pep-badge">{badge}</span>}

        <div className="hadacy-pep-img-wrap">
          {image ? (
            <img src={image} alt={name || "preview"} />
          ) : (
            <span className="hadacy-pep-img-empty">Sin imagen</span>
          )}
        </div>

        <div className="hadacy-pep-body">
          {kicker && <span className="hadacy-pep-kicker">{kicker}</span>}

          <h3 className="hadacy-pep-name">{name || "Nombre del producto"}</h3>

          {inspo && (
            <span className="hadacy-pep-inspo">inspirado en {inspo}</span>
          )}
          {brand && tipo === "perfumes" && (
            <span className="hadacy-pep-brand">{brand}</span>
          )}

          <div className="hadacy-pep-stars">
            ★★★★★ <span className="reviews">0 reviews</span>
          </div>

          <p className="hadacy-pep-price">
            ${priceLabel}
            <span className="mxn">(MXN)</span>
            {volume && <span className="hadacy-pep-volume">{volume}</span>}
          </p>

          {noteList.length > 0 && (
            <div className="hadacy-pep-notes">
              {noteList.slice(0, 4).map((n) => (
                <span className="hadacy-pep-tag" key={n}>
                  {n}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="hadacy-pep-tip">
        Así se verá la tarjeta del producto en la página principal.
      </div>
    </div>
  );
};

const ProdcuctEditScreen = ({ history }) => {
  const { id } = useParams();
  const productId = id;

  const [uploadFile, setUploadFile] = useState("");
  const [cloudinaryImage, setCloudinaryImage] = useState("");
  // Local in-browser preview URL (blob:...) for an image that hasn't been uploaded yet.
  // It's kept separate from `image` (which holds the canonical/Cloudinary URL) so we don't
  // pollute the URL text input with a transient blob URL.
  const [localImagePreview, setLocalImagePreview] = useState("");

  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  let [image, setImage] = useState("");
  const [brand, setBrand] = useState("");
  const [category, setCategory] = useState("");
  const [countInStock, setCountInStock] = useState("");
  const [description, setDescription] = useState(0);
  const [ingredients, setIngredients] = useState("");
  const [modeOfUse, setModeOfUse] = useState("");
  const [tipo, setTipo] = useState("cosmeticos");
  const [genero, setGenero] = useState(""); // "" or "dama" | "caballero" | "unisex"
  // ── Catalog-style optional fields (mainly perfumes) ──
  const [inspo, setInspo] = useState("");
  const [profile, setProfile] = useState("");
  const [idealFor, setIdealFor] = useState("");
  const [notes, setNotes] = useState(""); // editor uses comma-separated string; submit converts to array
  const [badge, setBadge] = useState("");
  const [volume, setVolume] = useState("");
  const [uploading, setUploading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const productDetail = useSelector((state) => state.productDetail);
  const { loading, error, product } = productDetail;

  const productUpdate = useSelector((state) => state.productUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = productUpdate;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: PRODUCT_UPDATE_RESET });
      navigate("/admin/productList");
    } else {
      if (!product.name || product._id !== productId) {
        dispatch(listProductDetails(productId));
      } else {
        setName(product.name);
        setPrice(product.price);
        setImage(product.image);
        setBrand(product.brand);
        setCategory(product.category);
        setCountInStock(product.countInStock);
        setDescription(product.description);
        setIngredients(product.ingredients);
        setModeOfUse(product.modeOfUse);
        setTipo(product.tipo || "cosmeticos");
        setGenero(product.genero || "");
        // Catalog-style optional fields (safe defaults for older docs)
        setInspo(product.inspo || "");
        setProfile(product.profile || "");
        setIdealFor(product.idealFor || "");
        setNotes(
          Array.isArray(product.notes)
            ? product.notes.join(", ")
            : product.notes || ""
        );
        setBadge(product.badge || "");
        setVolume(product.volume || "");
      }
    }
  }, [dispatch, product, productId, successUpdate, navigate]);

  const uploadFileHandler = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", uploadFile);
      formData.append("upload_preset", "HADACY");
      return await axios.post(
        "https://api.cloudinary.com/v1_1/cc1991/image/upload",
        formData
      )
        .then((response) => {
          setCloudinaryImage(response.data.secure_url);
          setImage(response.data.url);
          setUploading(false);
          // Now that we have a real URL, drop the local blob preview
          if (localImagePreview) {
            URL.revokeObjectURL(localImagePreview);
            setLocalImagePreview("");
          }
          return response.data.url;
        })
        .catch((error) => {
          console.log("ERROR");
          console.log(error);
          setUploading(false);
        });
    } catch (error) {
      console.log(error);
      setUploading(false);
    }
  };

  // Selecting a file: stash it for upload AND create a local blob URL so the
  // right-hand preview can show the image immediately, before submit.
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setUploadFile(file);
    // Replace any prior blob URL to avoid leaks
    if (localImagePreview) URL.revokeObjectURL(localImagePreview);
    setLocalImagePreview(URL.createObjectURL(file));
  };

  // Revoke any pending blob URL on unmount
  useEffect(() => {
    return () => {
      if (localImagePreview) URL.revokeObjectURL(localImagePreview);
    };
  }, [localImagePreview]);

  const submitHandler = async (e) => {
    e.preventDefault();
    image = uploadFile != "" ? await uploadFileHandler(e) : image;

    // Convert the comma-separated notes input into an array for the API
    const notesArray = notes
      .split(",")
      .map((n) => n.trim())
      .filter(Boolean);

    dispatch(
      updateProduct({
        _id: productId,
        name,
        price,
        image,
        brand,
        category,
        description,
        ingredients,
        modeOfUse,
        countInStock,
        tipo,
        genero,
        // Catalog-style optional fields
        inspo,
        profile,
        idealFor,
        notes: notesArray,
        badge,
        volume,
      })
    );
    dispatch(listProductDetails(productId));
  };

  return (
    <>
      <Link to="/admin/productList" className="btn btn-light my-3">
        Go Back
      </Link>

      <Container fluid="lg">
        <h1 className="mb-3">Editar producto</h1>

        {loadingUpdate && <Loader />}
        {errorUpdate && <Message variant="danger">{errorUpdate}</Message>}

        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <Row>
            {/* ─────────── FORM (left) ─────────── */}
            <Col xs={12} lg={7}>
              <Form onSubmit={submitHandler}>
                {/* ── BÁSICOS ── */}
                <h5 className="mt-2 mb-1">Datos básicos</h5>
                <p className="text-muted small mb-3">
                  La información esencial del producto. El nombre y el precio se
                  muestran prominentemente en la tarjeta de la página principal.
                </p>

                <Form.Group controlId="name" className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "Ary"'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Nombre que aparecerá como título de la tarjeta del producto.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="price" className="mb-3">
                  <Form.Label>Precio (MXN)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="399"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Precio en pesos mexicanos. Se muestra como{" "}
                    <em>$399.00 (MXN)</em> en la tarjeta.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="image" className="mb-3">
                  <Form.Label>Imagen</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="URL de la imagen (https://...)"
                    value={image}
                    onChange={(e) => setImage(e.target.value)}
                  />
                  <Form.Control
                    type="file"
                    label="Choose File"
                    custom
                    onChange={handleFileSelect}
                    className="mt-2"
                  />
                  {uploading && <Loader />}
                  <Form.Text className="text-muted">
                    Pega una URL o sube un archivo (se guarda en Cloudinary). La
                    imagen se muestra cuadrada en la tarjeta — usa fotos
                    centradas para mejor resultado.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="countInStock" className="mb-3">
                  <Form.Label>Inventario disponible</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0"
                    value={countInStock}
                    onChange={(e) => setCountInStock(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Cantidad disponible para venta. Si es 0, el cliente verá
                    "agotado".
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="brand" className="mb-3">
                  <Form.Label>Marca</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "Ariana Grande" (para perfumes inspirados)'
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    En perfumes, esta es la marca/celebridad del original (ej.
                    "Ariana Grande"). Aparece debajo del nombre en mayúsculas.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="category" className="mb-3">
                  <Form.Label>Categoría interna</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "perfume femenino"'
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Categoría libre para uso interno (no se muestra en la
                    tarjeta).
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="description" className="mb-3">
                  <Form.Label>Descripción</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder='Ej: "Dulce y femenino con notas de pera, frambuesa y un corazón de iris envuelto en almizcle cálido."'
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Texto descriptivo que aparece en la página de detalle del
                    producto (no en la tarjeta).
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="ingredients" className="mb-3">
                  <Form.Label>Ingredientes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Lista de ingredientes / componentes"
                    value={ingredients}
                    onChange={(e) => setIngredients(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Aplica sobre todo a cosméticos. Se muestra en la página de
                    detalle.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="modeOfUse" className="mb-3">
                  <Form.Label>Modo de uso</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Cómo aplicar el producto"
                    value={modeOfUse}
                    onChange={(e) => setModeOfUse(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Instrucciones de uso. Se muestra en la página de detalle.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="tipo" className="mb-3">
                  <Form.Label>Tipo de producto</Form.Label>
                  <Form.Control
                    as="select"
                    value={tipo}
                    onChange={(e) => setTipo(e.target.value)}
                  >
                    <option value="cosmeticos">Cosméticos</option>
                    <option value="perfumes">Perfumes</option>
                  </Form.Control>
                  <Form.Text className="text-muted">
                    Determina en qué sección del catálogo aparece. Si es
                    "perfumes", se habilitan los campos de género y catálogo.
                  </Form.Text>
                </Form.Group>

                {tipo === "perfumes" && (
                  <Form.Group controlId="genero" className="mb-3">
                    <Form.Label>Género</Form.Label>
                    <Form.Control
                      as="select"
                      value={genero}
                      onChange={(e) => setGenero(e.target.value)}
                    >
                      <option value="">Selecciona una opción</option>
                      <option value="dama">Dama</option>
                      <option value="caballero">Caballero</option>
                      <option value="unisex">Unisex</option>
                    </Form.Control>
                    <Form.Text className="text-muted">
                      Permite que el cliente filtre el catálogo por
                      Mujer/Hombre/Unisex. Aparece como kicker en la tarjeta:{" "}
                      <em>DAMA · FLORAL</em>.
                    </Form.Text>
                  </Form.Group>
                )}

                {/* ── CATÁLOGO ── */}
                <hr className="mt-4" />
                <h5 className="mt-3 mb-1">Catálogo (opcional)</h5>
                <p className="text-muted small mb-3">
                  Información adicional que enriquece la tarjeta del producto y
                  el catálogo. Todos los campos son opcionales — el producto
                  funciona sin ellos.
                </p>

                <Form.Group controlId="inspo" className="mb-3">
                  <Form.Label>Inspirado en</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "Ari"'
                    value={inspo}
                    onChange={(e) => setInspo(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    El nombre del perfume original. Se muestra debajo del nombre
                    como <em>"inspirado en Ari"</em>.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="profile" className="mb-3">
                  <Form.Label>Perfil olfativo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "Floral", "Amaderado", "Cítrico", "Oriental"'
                    value={profile}
                    onChange={(e) => setProfile(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Familia olfativa principal. Se muestra al lado del género en
                    el kicker (ej: <em>DAMA · FLORAL</em>).
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="idealFor" className="mb-3">
                  <Form.Label>Ideal para</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="uso diario, oficina y regalo femenino"
                    value={idealFor}
                    onChange={(e) => setIdealFor(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Ocasiones o situaciones recomendadas. Se usa en la página
                    de detalle del catálogo.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="notes" className="mb-3">
                  <Form.Label>Notas</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="pera, iris, almizcle"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Notas/ingredientes principales <strong>separados por
                    coma</strong>. Se muestran como etiquetas debajo del precio
                    (máx. 4 visibles).
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="volume" className="mb-3">
                  <Form.Label>Volumen</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "100 ML"'
                    value={volume}
                    onChange={(e) => setVolume(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Tamaño del envase. Aparece como pastilla redonda al lado del
                    precio.
                  </Form.Text>
                </Form.Group>

                <Form.Group controlId="badge" className="mb-3">
                  <Form.Label>Badge / etiqueta</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder='Ej: "favorita", "nuevo", "más vendido"'
                    value={badge}
                    onChange={(e) => setBadge(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Etiqueta destacada (opcional). Se muestra como cápsula
                    oscura en la esquina superior izquierda de la imagen.
                  </Form.Text>
                </Form.Group>

                <Button type="submit" variant="primary" className="my-3">
                  Actualizar producto
                </Button>
              </Form>
            </Col>

            {/* ─────────── PREVIEW (right, sticky) ─────────── */}
            <Col xs={12} lg={5} className="mt-4 mt-lg-0">
              <ProductPreview
                name={name}
                price={price}
                image={localImagePreview || image}
                brand={brand}
                tipo={tipo}
                genero={genero}
                inspo={inspo}
                profile={profile}
                notes={notes}
                volume={volume}
                badge={badge}
              />
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
};

export default ProdcuctEditScreen;
